export const styles = () => ({
  closeBtn: {
    position: 'absolute',
    top: 20,
    right: 20,
    color: '#2D333B',
  },
  dialogTitle: {
    '& h6': { fontWeight: '500' },
  },
  content: { background: '#E5F0FF' },
  grid: { margin: '30px 0' },
  bold: { fontWeight: 600 },
  asset: { fontWeight: 600, wordBreak: 'break-word' },
  btnTxt: { color: '#fff' },
  date: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  powerOnBtn: {
    background: '#01D38B',
    borderRadius: '50%',
    color: '#fff',
  },
  powerOffBtn: { background: '#F41313', borderRadius: '50%', color: '#fff' },
  saveBtn: {
    color: '#fff',
    display: 'flex',
    margin: '40px auto',
    width: 330,
    height: 60,
    background: '#01D38B',
    borderRadius: 30,
    '&:hover': {
      background: '#01D38B',
      opacity: 0.8,
    },
  },
  employmentRequest: { marginTop: 10 },
  employmentDate: { marginTop: 10 },
  header: {
    margin: '20px 0',
    fontWeight: 600,
  },
});
